import React from 'react'
import { Box } from 'components/Layout'
import Button from 'components/Button'
import Icon from 'components/Icon'
import { AddSubperson } from 'sharedComponents/AboutUser/AddSubperson'

export interface SubpersonInputProps {
  userId?: string
  refetch?: () => void
  isDisabled?: boolean
}

const SubpersonInput = ({ userId, refetch, isDisabled }: SubpersonInputProps) => {
  const [isAddingSubperson, setIsAddingSubperson] = React.useState(false)

  return (
    <>
      <Box mb="1rem">
        {!isDisabled && (
          <Button
            size="medium"
            appearance="ghost"
            leftIcon={
              <>
                <Icon.Plus />
                <Icon.Person />
              </>
            }
            colorVariant="primary"
            onClick={() => {
              setIsAddingSubperson(!isAddingSubperson)
            }}
          >
            Add subperson
          </Button>
        )}
        <AddSubperson
          userId={String(userId)}
          isOpen={isAddingSubperson}
          onDismiss={() => setIsAddingSubperson(false)}
          refetch={refetch}
        />
      </Box>
    </>
  )
}

export { SubpersonInput }
